module.exports = __webpack_public_path__ + "static/media/money-to-home.87304846.webp";